export default "images/github-logo.png";